import axios from 'axios';

// API endpoints come from the build environment (deploy/deploy.sh injects the
// right values per target); the fallbacks are local development. No more
// comment-toggling between Local/Live blocks before a deploy build.
export const APIURL = process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1/";
export const IMAGEPATH = process.env.REACT_APP_IMAGE_PATH || "http://localhost:3001";
export const WEB_URL = process.env.REACT_APP_WEB_URL || "http://localhost:3000";


const apiHelper = () => {

    const methods = ["get", "post", "put", "patch", "delete"];
    const generateAxiosInstance = (contentType: any, timeout: any) => {
        return axios.create({
            headers: {
                'Content-Type': contentType || 'application/json',
            },
            timeout: timeout || 15000,
        });
    };

    const api = async ({
        url,
        method,
        params = null,
        body = null,
        contentType = null,
        headers = {},
        timeout = undefined,
    }: {
        url: string;
        method: string;
        params?: any;
        body?: any;
        contentType?: string | null;
        headers?: Record<string, string>;
        timeout?: number;
    }) => {
        const axiosInstance: any = generateAxiosInstance(contentType, timeout);
        method = method.toLowerCase();

        if (methods.includes(method)) {
            const request = axiosInstance[method];
            let args: any[] = [url];

            if (method === "get" || method === "delete") {
                args.push({ params, headers });
            } else {
                args.push(body, { headers });
            }

            return request(...args).then((res: any) => res).catch((err: any) => {
                if (err?.status === 403) {
                    localStorage.clear();

                    window.location.replace('/home');
                    // alert(err?.response?.data?.message || 'Access denied.')
                }
                console.error("API request error:", err);
                return err?.response;
            });
        } else {
            throw new Error(`Invalid HTTP Method - ${method}`);
        }
    };

    return { api };
}

export default apiHelper;
